import React from 'react';

import shouldIcon from 'src/public/img/undraw_lost_bqr2.svg';
import shouldNotIcon from 'src/public/img/undraw_thoughts_e49y.svg';

import * as S from '../../stepComponents/styles';
import { CommonReactionsBox } from '../components/CommonReactionsBox';

const listWhatShould = [
    'Choose someone you feel comfortable talking to (e.g., partner, friend, spiritual leader, co-worker, family member)',
    'Find a time and space that you feel comfortable',
    'Ask for what you need (e.g., just want them to listen, or want them to offer advice)',
    'Express appreciation',
];

const listWhatShouldNot = [
    'Not talk to someone for fear of being annoying or upsetting them',
    'Worry about being a burden - your loved ones want to help',
    'Wait until you are feeling so stressed that it is overwhelming',
];

export const GettingSupportStep: React.SFC = () => (
    <>
        <S.ContentRow>
            <S.ContentColumn>
                <S.StepHeading>Getting Support</S.StepHeading>
                <S.StepDescription small>
                    It sometimes feels difficult or scary to ask for support after this type of
                    event. Here are some helpful things to keep in mind.
                </S.StepDescription>
            </S.ContentColumn>
        </S.ContentRow>
        <S.ContentRow type="flex">
            <CommonReactionsBox
                isHorizontal
                title="What should I do?"
                icon={shouldIcon}
                list={listWhatShould}
            />
            <CommonReactionsBox
                isHorizontal
                title="What shouldn’t I do?"
                icon={shouldNotIcon}
                list={listWhatShouldNot}
            />
        </S.ContentRow>
    </>
);
